/**
* @license lucide-solid v0.354.0 - ISC
*
* This source code is licensed under the ISC license.
* See the LICENSE file in the root directory of this source tree.
*/

// src/icons/graduation-cap.tsx
import Icon from "../Icon";
var iconNode = [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
];
var GraduationCap = (props) => <Icon {...props} name="GraduationCap" iconNode={iconNode} />;
var graduation_cap_default = GraduationCap;
export {
  graduation_cap_default as default
};
//# sourceMappingURL=graduation-cap.jsx.map
